import React, { useState, useEffect } from 'react'
import { DappMenuSreen } from '../UI/DappMenuSreen'

import Avatar from '@mui/material/Avatar';


import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import TextField from '@mui/material/TextField';
import { app, db, storages } from "../../firebaseConfig/firebaseConfig";
import {  doc, getDoc, updateDoc } from 'firebase/firestore/lite';
import {ref, uploadString, uploadBytes, getDownloadURL,deleteObject , uploadBytesResumable } from 'firebase/storage'

import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import * as moment from 'moment';


export const DappMyProfile = () => {

    const [selectedImage, setSelectedImage] = useState();


    const [email, setemail] = useState('')
    const [password, setpassword] = useState('')
    const [name, setname] = useState('')
    const [wallet, setwallet] = useState('')
    const [img, setImage] = useState()

  const [open, setOpen] = useState(false);



  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };


    const getInfo = async () => {
        const myuser = localStorage.getItem("uid");
        console.log(myuser);
        const docRef = doc(db, "users", myuser);
        const docSnap = await getDoc(docRef);


        if (!docSnap.exists) {
            console.log('No such document!');
        } else {
            console.log('Document data:', docSnap.data());
            //name = docSnap.data().name;
            let data = docSnap.data();
            console.log(data.name, "dede")
            setname(data.name);
            setpassword(data.password);
            setwallet(data.wallet);
            setemail(data.email);
            if(data.img != undefined){
                setImage(data.img);
                console.log(data.img);
                
            }

        }
    }


    useEffect(() => {
        getInfo();
        return () => {

        }
    }, [])




    const handleSubmit = async (e) => {
        console.log(name, email, password, "all that")
        console.log(selectedImage);
        if(selectedImage != null){

        }else{

        }
        const myuser = localStorage.getItem("uid");
        console.log(myuser);
        const docRef = doc(db, "users", myuser);
        const newData = {
            name: name,
            password: password,
            wallet: wallet
        }
        await updateDoc(docRef, newData);

    setOpen(true);
    getInfo();
        //const task = StorageReference().child('profile/'+ new Date()).put(selectedImage)

        try {
            //await task
        } catch (err) {
            console.log(err)
        }

    }

    // This function will be triggered when the file field change
    const imageChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if(e.target.files[0].size > 2000000){
                alert("Solo se aceptan archivos con un máximo de 2mb")
                return;
            }
            console.log(e.target.files[0],"x");
            setSelectedImage(e.target.files[0]);
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = async() => {
             
              console.log((reader));
              console.log(typeof(reader.result));
              let file = reader.result;
              file = file.split(",");
              console.log(file[1]);
              const metadata = {
                contentType: e.target.files[0].type
              };


              const myuser = localStorage.getItem("uid");
              const data = await uploadString(ref(storages,"images/"+myuser),file[1], 'base64' ,metadata);
              const link = await getDownloadURL(ref(storages,"images/"+myuser));
                     
              console.log('Uploaded a blob or file!', link);
          
          const docRef = doc(db, "users", myuser);
          const newData = {
              img: link
          }
          await updateDoc(docRef, newData);
          console.log(updateDoc);
          getInfo();
        }

       
             
                     
        }
    };

    // This function will be triggered when the "Remove This Image" button is clicked
    const removeSelectedImage = () => {
        setSelectedImage();
    };


    const action = (
        <React.Fragment>
          <Button color="secondary" size="small" onClick={handleClose}>
            
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );


    return (
        <div>
            <div className="dapp_container">

            <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message="Perfil editado con exito"
        action={action}
      />

                <DappMenuSreen />

                <h4 style={{ marginTop: "130px", textAlign: "center", fontSize: "28px" }}>Mi perfil </h4>

                

                <div className="dapp__profileimg">
                    <input
                        accept="image/*"
                        type="file"
                        onChange={(event) => imageChange(event) }
                      
                    />

                    {(!selectedImage && img == null) && (
                        <Avatar className="dapp__avatar" alt="Remy Sharp" />
                    )}

                    { (selectedImage && img == null) &&  (

                        <Avatar className="dapp__avatar" alt="Remy Sharp" src={URL.createObjectURL(selectedImage)} />


                    )}

{ ( img != null) &&  (
<Avatar className="dapp__avatar" alt="Remy Sharp"  src={(img)} />

)}
                    
                </div>


                <form className="dapp__formprofile" onSubmit={handleSubmit}>
                    <Box
                        className="login__formbox"
                        component="form"
                        sx={{
                            width: 400,
                            maxWidth: '100%'
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <TextField
                            label=" Nombre"
                            className="login__input"
                            name="name"
                            type="text"
                            variant="filled"
                            value={name}
                            onChange={(e) => setname(e.target.value)}

                        />
                        <br></br>
                        <TextField

                            label="Email"
                            name="email"
                            disabled
                            type="email"
                            className="login__input"
                            value={email}
                            onChange={(e) => setemail(e.target.value)}
                            variant="filled"

                        />


                        <TextField
                            disabled
                            label="wallet"
                            name="wallet"
                            type="text"
                            className="login__input"
                            value={wallet}
                            onChange={(e) => setwallet(e.target.value)}
                            variant="filled"

                        />




                     








                    </Box>
                    <Button className="dapp__button" onClick={handleSubmit} variant="contained">Editar </Button>

                </form>
            </div>
        </div>
    )
}
